import { toName } from 'shared'

export function matchPhysician(roster: { id: number, name: string }[], raw: string) {
  const canonical = toName(raw, 'name')
  return { canonical, match: roster.find((p) => p.name === canonical) }
}
